import { faCheck, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'component-library';
import { LatestSoftwareVersion, SystemDetail } from '../../../models/ApiModels';
import { GetLatestSoftwareVersion } from '../../../services/SoftwareUpdateService';
import useRequest from '../../../utils/net/useRequest';
import useWindowSize from '../../../utils/UseWindowSize';

export default function SystemDetailsCTACheckList({ system }: { system: SystemDetail }) {
  const windowSize = useWindowSize();
  const [latestSoftwareVersion] = useRequest<LatestSoftwareVersion>(() => GetLatestSoftwareVersion(), []);
  const isInGroup = system.group?.id !== undefined && system.group?.id !== null;

  const isSystemUpdated = () => {
    return (
      system.lightningHardwareSystem?.controlUnit?.firmwareVersion === latestSoftwareVersion?.lcuVersion &&
      system.lightningHardwareSystem?.starboardServo?.firmwareVersion === latestSoftwareVersion?.lsuVersion &&
      system.lightningHardwareSystem?.portServo?.firmwareVersion === latestSoftwareVersion?.lsuVersion &&
      system.lightningHardwareSystem?.primaryControlPanel?.firmwareVersion === latestSoftwareVersion?.lcpVersion
    );
  };

  const isBoatModelAssigned = () => {
    return system.boatModelId;
  };

  const isSettingsConfigured = () => {
    const hasMetadata =
      system.lightningHardwareSystem?.controlUnit?.metadata?.fileName !== null &&
      system.lightningHardwareSystem?.primaryControlPanel?.metadata?.fileName !== null;
    return (
      hasMetadata &&
      system.lightningHardwareSystem?.controlUnit?.metadata?.at_Amplitude !== 0 &&
      system.lightningHardwareSystem?.controlUnit?.metadata?.axisConfig !== 255
    );
  };

  const isWarrantyValid = () => {
    return system.warrantySubmissionDate;
  };

  const checklistItems = [
    {
      name: 'latest software',
      isChecked: isSystemUpdated(),
      tooltip: 'This will show if the system has the latest software, if not update it on the system itself.',
    },
    {
      name: 'configured settings',
      isChecked: isSettingsConfigured(),
      tooltip:
        'This will show if the system at least has configured base system, it’s no guarantee for correct settings unless a preset is assigned. This will have to be configured in the system itself and cannot be done though the portal.',
    },
    {
      name: 'extended warranty',
      isChecked: isWarrantyValid(),
      tooltip:
        'This will show if the system has the latest software version installed. If not, it has to be updated on the hardware system itself.',
    },
    {
      name: 'assign boat model',
      isChecked: isBoatModelAssigned(),
      tooltip:
        'This will show if there is a boat model assigned to this system, if not, assign the correct boat model through the portal.',
    },
  ];

  return (
    <ul>
      {checklistItems
        .filter((item) => !(item.name === 'latest software' && isInGroup))
        .map((item, index) => (
          <li key={index}>
            <div className='flex items-center justify-between gap-2 py-2 border-b border-gray-40'>
              <div className='flex gap-2'>
                <span className={`uppercase whitespace-nowrap ${item.isChecked ? 'text-primary-100' : 'text-black'}`}>
                  {item.name}
                </span>
                <Tooltip position={windowSize?.width >= 1280 ? 'left' : 'right'} description={item.tooltip} />
              </div>
              <span
                className={`prose-paragraphBig flex items-center justify-center ${
                  item.isChecked ? '  text-primary-100' : '  text-error-200'
                }`}
              >
                <FontAwesomeIcon icon={item.isChecked ? faCheck : faX} />
              </span>
            </div>
          </li>
        ))}
    </ul>
  );
}
